import crypto from "node:crypto";
import type { WakeLoopRequestContext } from "@wakeloop/schemas/types";
import type { WakeLoopProfile } from "./wakeloop-profiles-api";

export type WakeLoopRequestContextProfileIdentity = {
  wakeLoopProfileId: string;
  profileKind?: "human" | "agent" | "system";
  kind?: "human" | "agent";
  profileHandle?: string;
  profileName: string;
  ownerUserId?: string;
  ownerName?: string;
  agentControllerConversationId?: string;
};

export function buildWakeLoopRequestContextFromProfile(input: {
  wakeLoopProfile: WakeLoopProfile;
  requestId?: string;
  agentControllerConversationId?: string;
}): WakeLoopRequestContext {
  const requestId =
    normalizeOptionalText(input.requestId) ?? crypto.randomUUID();
  const agentControllerConversationId = normalizeOptionalText(
    input.agentControllerConversationId
  );
  const ownerName = normalizeOptionalText(input.wakeLoopProfile.ownerName);

  return {
    actorContext: {
      requestId,
      wakeLoopProfileId: input.wakeLoopProfile.wakeLoopProfileId,
      profileKind: input.wakeLoopProfile.profileKind,
      profileHandle: input.wakeLoopProfile.profileHandle,
      profileName: input.wakeLoopProfile.profileName,
      ownerUserId: input.wakeLoopProfile.ownerUserId,
      ...(ownerName ? { ownerName } : {}),
    },
    ...(agentControllerConversationId ? { agentControllerConversationId } : {}),
  };
}

export function buildWakeLoopRequestContextFromProfileIdentity(input: {
  profileIdentity: WakeLoopRequestContextProfileIdentity;
  requestId?: string;
}): WakeLoopRequestContext {
  const requestId =
    normalizeOptionalText(input.requestId) ?? crypto.randomUUID();
  const profileHandle = normalizeOptionalText(
    input.profileIdentity.profileHandle
  );
  const ownerUserId = normalizeOptionalText(input.profileIdentity.ownerUserId);
  const ownerName = normalizeOptionalText(input.profileIdentity.ownerName);
  const agentControllerConversationId = normalizeOptionalText(
    input.profileIdentity.agentControllerConversationId
  );
  const profileKind =
    input.profileIdentity.profileKind ??
    (input.profileIdentity.kind === "human" ||
    input.profileIdentity.kind === "agent"
      ? input.profileIdentity.kind
      : "system");

  return {
    actorContext: {
      requestId,
      wakeLoopProfileId: input.profileIdentity.wakeLoopProfileId,
      profileKind,
      ...(profileHandle ? { profileHandle } : {}),
      profileName: input.profileIdentity.profileName,
      ...(ownerUserId ? { ownerUserId } : {}),
      ...(ownerName ? { ownerName } : {}),
    },
    ...(agentControllerConversationId ? { agentControllerConversationId } : {}),
  };
}

function normalizeOptionalText(value: unknown): string | null {
  const normalized = String(value ?? "").trim();
  return normalized.length > 0 ? normalized : null;
}
